import { render, staticRenderFns } from "./RightItemView3.vue?vue&type=template&id=2304cd5e&scoped=true&"
import script from "./RightItemView3.vue?vue&type=script&lang=ts&"
export * from "./RightItemView3.vue?vue&type=script&lang=ts&"
import style0 from "./RightItemView3.vue?vue&type=style&index=0&id=2304cd5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2304cd5e",
  null
  
)

export default component.exports